import { React, ui, observer } from "aaa";

export const A11yPopupHider = observer((props: { children: any }) => (
    <div aria-hidden={ui.isPopupVisible}>
        {props.children}
    </div>
));


// WEBPACK FOOTER //
// ./src/components/common/A11yPopupHider.tsx